import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { dateToString } from '../../../utilities/formattingUtilities';
import { MedicalClaim } from './types';

type AutoMedicalClaimsClaimsTableProps = {
  claims: MedicalClaim[];
};

export const AutoMedicalClaimsClaimsTable = ({
  claims,
}: AutoMedicalClaimsClaimsTableProps) => {
  return (
    <Table size="small" className="auto-medical-claims-claims-table">
      <TableHead>
        <TableRow>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Claim ID
          </TableCell>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Service Date
          </TableCell>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Code Type
          </TableCell>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Code
          </TableCell>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Description
          </TableCell>
          <TableCell className="auto-medical-claims-claims-head-cell">
            Provider (NPI)
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {claims.map(claim => (
          <TableRow key={claim.id}>
            <TableCell>
              <div className="auto-medical-claims-claim-id">{claim.id}</div>
            </TableCell>
            <TableCell>
              <div className="auto-medical-claims-claim-service-date">
                {dateToString(claim.visitDate)}
              </div>
            </TableCell>
            <TableCell>
              <span className="auto-medical-claims-code-type-badge">
                {claim.codeType}
              </span>
            </TableCell>
            <TableCell>
              <div className="auto-medical-claims-claim-code">{claim.code}</div>
            </TableCell>
            <TableCell>
              <div className="auto-medical-claims-claim-description">
                {claim.description}
              </div>
            </TableCell>
            <TableCell>
              <div className="auto-medical-claims-provider">{claim.name}</div>
              <div className="auto-medical-claims-provider-specialization">
                {`${claim.specialization}`}
              </div>
              <div className="auto-medical-claims-provider-npi">
                {`NPI: ${claim.npi}`}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
